import { render, staticRenderFns } from "./InfoText.vue?vue&type=template&id=465f0193&scoped=true"
import script from "./InfoText.vue?vue&type=script&lang=js"
export * from "./InfoText.vue?vue&type=script&lang=js"
import style0 from "./InfoText.vue?vue&type=style&index=0&id=465f0193&prod&lang=scss&scoped=true"
import style1 from "./InfoText.vue?vue&type=style&index=1&id=465f0193&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465f0193",
  null
  
)

export default component.exports